import { Injectable } from '@angular/core';
import { ProjectModule } from '../../resources/module/project-module.interface';
import { ProjectSubmodule } from '../../resources/submodule/project-submodule.interface';
import { ProjectElement } from '../../resources/element/project-element.interface';
import { ScrollToConfig } from './scroll-to.interface';

/**
 * Scroll to requested entity.
 *
 * @todo Config object, with properties such as:
 *  - behavior: smooth / instant
 *  - position: start / center / end
 *  - flash: true / false
 *
 * Supports the following id's
 * - Module: #module
 * - Submodule: #module-submodule
 * - Element: #module-submodule-element
 * - Building: #building
 * - Cluster: #building-cluster
 * - Area: #building-cluster-area
 */
@Injectable({
  providedIn: 'root'
})
export class ScrollToService {

  /** Default config. */
  private readonly DEFAULT_CONFIG = { };

  /**
   * Scroll to HTMLElement.
   *
   * @param id Entity id.
   * @param [config] Scroll config.
   */
  public find(id: ProjectElement['_id'] | ProjectModule['_id'] | ProjectSubmodule['_id'], config?: ScrollToConfig): void {
    this._scrollTo(id, { ...this.DEFAULT_CONFIG, ...config });
  }

  /**
   * Find document element and scroll to position.
   *
   * @todo Animation should be done *after* the scroll, not with a timeout.
   *
   * @param id The document element's id.
   * @param [config] Scroll config.
   */
  private _scrollTo(id: string, config: ScrollToConfig): void {
    setTimeout(() => {
      const el = document.getElementById(id) as HTMLElement;
      if (el) {
        const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({
          top: yCoordinate - 190 + (config.offset || 0),
          behavior: 'smooth'
        });
        setTimeout(() => {
          el.style.animationDuration = '0.5s';
          if (config.animate) {
            el.classList.add('animated', config.animate);
          }
        }, 750);
      }
    }, 250);
  }
}
